import axios from 'axios';
import { vendorCategoryNames } from '@/lib/vendorCategories';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isCategoryEnabled = (category) => {
  if (!category) return false;
  if (category.visible === false) return false;
  if (category.is_active === false) return false;
  if (typeof category.status === 'string') {
    const normalizedStatus = category.status.trim().toLowerCase();
    if (["inactive", "disabled", "archived"].includes(normalizedStatus)) {
      return false;
    }
  }
  return true;
};

export const extractEnabledCategoryNames = (categories) => {
  if (!Array.isArray(categories)) return [];

  return categories
    .filter(isCategoryEnabled)
    .map((category) => String(category.name || '').trim())
    .filter(Boolean);
};

export const mergeWithSelectedCategories = (baseCategories, selectedCategories = []) => {
  const merged = [...(baseCategories || [])];
  (selectedCategories || []).forEach((category) => {
    if (category && !merged.includes(category)) {
      merged.push(category);
    }
  });
  return merged;
};

export const mergeOrderedCategoryObjects = (apiCategories = [], fallbackCategories = []) => {
  const normalizedApiCategories = (apiCategories || []).map((category) => ({
    ...category,
    slug: category.slug || String(category.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-'),
  }));

  if (normalizedApiCategories.length === 0) {
    return fallbackCategories;
  }

  return normalizedApiCategories;
};

export const fetchVendorSelectableCategories = async () => {
  try {
    const response = await axios.get(`${API}/categories`);
    const names = extractEnabledCategoryNames(response.data);
    if (names.length > 0) {
      return names;
    }
  } catch (error) {
    console.warn('Failed to fetch vendor-selectable categories, using fallback list.', error);
  }

  return vendorCategoryNames;
};
